<script setup>
import { ref, watch, computed } from 'vue';

import { 
  kPage, 
  kBlockTitle,
  kList,
  kListItem,
  kSearchbar
} from 'konsta/vue';

import {useBooking} from '@/stores/booking'
const bookingStore = useBooking();

import {useConfig} from '@/stores/config'
const configStore = useConfig();

const search = ref('');

const services = computed(_ => {
  if(!configStore.config.services) return [];
  if(search.value == '') return configStore.config.services;
  
  return configStore.config.services?.filter(s => s.name.toLowerCase().includes(search.value.toLowerCase()))
})

const services_bundles = computed(_ => {
  if(search.value == '') return configStore.config.services_bundles;
  
  return configStore.config.services_bundles?.filter(s => s.name.toLowerCase().includes(search.value.toLowerCase()))
})

const is_bnb = computed(_ => configStore.config.layout === 'layout_b&b')

</script>


<template>

  <k-searchbar
    :value="search"
    placeholder="Cerca"
    disable-button
    disable-button-text="Annulla"
    @clear="search = ''"
    @input="e => search = e.target.value"
  />

  <template v-if="configStore.config.service_bundles_enabled">
    <k-block-title>Seleziona un pacchetto:</k-block-title>

    <k-list strong outline>
      <k-list-item 
        v-if="!services_bundles.length"
        title="Nessun risultato"
      />
      <k-list-item
        v-for="bundle in services_bundles"
        :chevron-material="false"
        link
        :title="bundle.name"
        :after="bundle.show_prices && bundle.price_with_tax ? bundle.price_with_tax.toFixed(2)+' €' : null"
        :subtitle="null"
        :text="bundle.description"
        @click="
          bookingStore.service_bundle = bundle; 
          bookingStore.track(); 
          bookingStore.goNextStep()"
      >
        <!-- <template #media>
          <img
            class="ios:rounded-lg material:rounded-full ios:w-20 material:w-10"
            src="https://cdn.framework7.io/placeholder/people-160x160-2.jpg"
            width="80"
            alt="demo"
          />
        </template> -->
      </k-list-item>

    </k-list>
  </template>


  <k-block-title>
    Seleziona un servizio:
  </k-block-title>    

  <k-list strong outline>
    <k-list-item 
      v-if="!services.length"
      title="Nessun risultato"
    />

    <k-list-item
      v-for="service in services"
      :chevron-material="false"
      link
      :title="service.name"
      :after="service.show_prices && service.price_with_tax && !is_bnb ? service.price_with_tax.toFixed(2)+' €' : null"
      :subtitle="null"
      @click="
        bookingStore.service_bundle = null;
        bookingStore.service = service; 
        bookingStore.track(); 
        bookingStore.goNextStep()"
    >
      <!-- <template #media>
        <img
          class="ios:rounded-lg material:rounded-full ios:w-20 material:w-10"
          src="https://cdn.framework7.io/placeholder/people-160x160-2.jpg"
          width="80"
          alt="demo"
        />
      </template> -->
      <template v-if="service.description" #text>
        <span v-html="service.description" class="!whitespace-normal !overflow-visible !line-clamp-none" />
      </template>
    </k-list-item>

  </k-list>

</template>
<!-- 
<style lang="scss">
.k-list-item-text {
  white-space: normal !important;
  overflow: visible !important;
  display: block !important;
  -webkit-line-clamp: unset !important;
}
</style> -->